import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Businesses from "./pages/Businesses";
import SharedServices from "./pages/SharedServices";
import Administration from "./pages/Administration";
import MarketingLayout from "./components/MarketingLayout";
import MarketingOverview from "./pages/marketing/Overview";
import BrandProfile from "./pages/marketing/BrandProfile";
import MediaSettings from "./pages/marketing/MediaSettings";
import Offers from "./pages/marketing/Offers";
import Campaigns from "./pages/marketing/Campaigns";
import ContentQueue from "./pages/marketing/ContentQueue";
import ContentDetail from "./pages/marketing/ContentDetail";
import KnowledgeBase from "./pages/marketing/KnowledgeBase";
import ApprovalInbox from "./pages/marketing/ApprovalInbox";
import CampaignDetail from "./pages/marketing/CampaignDetail";
import BrandAssets from "./pages/marketing/BrandAssets";
import MediaReview from "./pages/marketing/MediaReview";
import Operations from "./pages/marketing/Operations";
import Calendar from "./pages/marketing/Calendar";
import Publishing from "./pages/marketing/Publishing";
import PublishingReport from "./pages/marketing/PublishingReport";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <Loader2 className="h-8 w-8 animate-spin text-[#581C87]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user && user !== null) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="shared-services" element={<SharedServices />} />
              <Route path="administration" element={<Administration />} />
              <Route path="marketing" element={<MarketingLayout />}>
                <Route index element={<MarketingOverview />} />
                <Route path="brand-profile" element={<BrandProfile />} />
                <Route path="media-settings" element={<MediaSettings />} />
                <Route path="offers" element={<Offers />} />
                <Route path="campaigns" element={<Campaigns />} />
                <Route path="campaigns/:id" element={<CampaignDetail />} />
                <Route path="content" element={<ContentQueue />} />
                <Route path="content/:id" element={<ContentDetail />} />
                <Route path="knowledge-base" element={<KnowledgeBase />} />
                <Route path="approval-inbox" element={<ApprovalInbox />} />
                <Route path="brand-assets" element={<BrandAssets />} />
                <Route path="media-review" element={<MediaReview />} />
                <Route path="operations" element={<Operations />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="publishing" element={<Publishing />} />
                <Route path="publishing-report" element={<PublishingReport />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
